(function () {

    'use strict';

    /**
     * Initiates the navigation.
     */
    const Navigation = function (element) {

        this.element = element;
        this.trigger = element.getElementsByTagName('BUTTON')[0];
        this.subs = element.getElementsByClassName('js-main__sub');
        this.breakpoint = matchMedia('(min-width: 64rem)');

        this.evaluateState = this.evaluateState.bind(this);
        this.presentNavigation = this.presentNavigation.bind(this);
        this.dismissNavigation = this.dismissNavigation.bind(this);

        this.initiateListener();
    }

    /**
     * Initiates the event listener.
     */
    Navigation.prototype.initiateListener = function () {

        this.trigger.addEventListener('pointerdown', this.evaluateState);
        this.trigger.addEventListener('keydown', this.evaluateState);

        for(const sub of this.subs) {
            new Navigation(sub);
        }
    }

    /**
     * Evaluates the state.
     */
    Navigation.prototype.evaluateState = function (event) {

        event.stopPropagation();

        if (this.trigger.getAttribute('aria-expanded') === 'false') {
            this.presentNavigation();

        } else {
            this.dismissNavigation(event);
        }
    }

    /**
     * Presents the navigation.
     */
    Navigation.prototype.presentNavigation = function () {

        this.trigger.setAttribute('aria-expanded', 'true');

        window.addEventListener('keyup', this.dismissNavigation);
        window.addEventListener('pointerdown', this.dismissNavigation);
        this.breakpoint.addEventListener('change', this.dismissNavigation);
    }

    /**
     * Dismisses the navigation.
     */
    Navigation.prototype.dismissNavigation = function (event) {

        let dismiss = false;

        // Dismisses when the window resizes
        if (event.type === 'change' && event.matches) {
            dismiss = true;
        }

        // Dismisses when escaped via key
        if (event.type === 'keyup' && event.key === 'Escape') {
            dismiss = true;
        }

        // Dismisses through focus via key
        if (event.type === 'keyup' && !event.target.closest('.js-main-nav')) {
            dismiss = true;
        }

        // Dismisses through focus via mouse
        if (event.type === 'pointerdown' && event.target === this.trigger) {
            dismiss = true;
        }

        // Dismisses through focus via mouse
        if(event.type === 'pointerdown' && !event.target.closest('.js-main-nav')) {
            dismiss = true;
        }

        if (dismiss) {

            this.trigger.setAttribute('aria-expanded', 'false');

            window.removeEventListener('keyup', this.dismissNavigation);
            window.removeEventListener('pointerdown', this.dismissNavigation);
            this.breakpoint.removeEventListener('change', this.dismissNavigation);
        }
    }

    const navigations = document.getElementsByClassName('js-main-nav');

    for (const navigation of navigations) {
        new Navigation(navigation);
    }
}());